import jwt from 'jsonwebtoken';
import Sdk from '@/sdk';

export default {
    namespaced: true,
    state: {
        currentUser: null,
    },
    getters: {
        isLoggedIn(state) {
            return state.currentUser !== null;
        },
        currentUser(state) {
            return state.currentUser;
        },
    },
    actions: {
        login(__, data) {
            return Sdk.Manager.Login(data);
        },
        logout() {
            return Sdk.Manager.Logout();
        },
        changePassword(__, data) {
            return Sdk.Manager.ChangePassword(data);
        },
        tryAutoLogin({ dispatch }) {
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    dispatch('updateToken', token);
                    Sdk.Manager.AutoRefreshToken();
                    return true;
                }
                return false;
            } catch (err) {
                console.log(err);
                return false;
            }
        },
        updateToken({ state }, token) {
            const profile = jwt.decode(token);
            state.currentUser = profile;
        },
    },
};
